import { c as _c } from "react/compiler-runtime";
import { InputMask } from '@react-input/mask';
import _ from 'lodash';
import { twMerge } from 'tailwind-merge';
type Props = {
  className?: string;
  label?: string | React.ReactNode;
  inline?: boolean;
  name?: string;
  value?: string | number | null | undefined;
  mask: string;
  prepend?: string | React.ReactNode;
  addon?: string | React.ReactNode;
  replacement: string | Record<string, RegExp>;
  placeholder?: string;
  maxLength?: number;
  type?: 'email' | 'numeric' | 'password' | 'search' | 'tel' | 'text' | 'url';
  disabled?: boolean;
  optional?: boolean;
} & React.ComponentPropsWithoutRef<'input'>;
export function MaskedText(props) {
  const $ = _c(47);
  const {
    className,
    label,
    inline,
    id,
    name,
    prepend,
    addon,
    type,
    mask,
    replacement,
    value,
    placeholder,
    maxLength,
    disabled,
    optional,
    onChange,
    onBlur,
    onFocus,
    "aria-label": ariaLabel
  } = props;
  let t0;
  if ($[0] !== props) {
    t0 = _.get(props, "data-error");
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const errMsg = t0;
  let t1;
  if ($[2] !== id || $[3] !== label || $[4] !== name || $[5] !== optional) {
    t1 = label && <label htmlFor={id || name} className="form-label">{label}{optional && <span className="ml-1.5 font-light text-zinc-600 dark:text-zinc-400">(optional)</span>}</label>;
    $[2] = id;
    $[3] = label;
    $[4] = name;
    $[5] = optional;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = inline ? "mt-0" : "mt-1";
  const t3 = disabled && "form-disabled";
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = twMerge("form-container", t2, t3);
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== prepend) {
    t5 = prepend && <div className="form-prepend">{prepend}</div>;
    $[10] = prepend;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = id || name;
  const t7 = type || "text";
  const t8 = type === "password" ? undefined : type as 'email' | 'search' | 'tel' | 'text' | 'url' | undefined;
  const t9 = value ?? "";
  const t10 = placeholder || "";
  const t11 = maxLength || undefined;
  let t12;
  if ($[12] !== className) {
    t12 = twMerge("form-input", className);
    $[12] = className;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = ariaLabel || (typeof label === "string" ? label : name);
  const t14 = !!errMsg;
  const t15 = errMsg ? `${id || name}-error` : undefined;
  let t16;
  if ($[14] !== disabled || $[15] !== mask || $[16] !== name || $[17] !== onBlur || $[18] !== onChange || $[19] !== onFocus || $[20] !== replacement || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t15 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t16 = <InputMask mask={mask} replacement={replacement} autoComplete="off" id={t6} name={name} type={t7} inputMode={t8} value={t9} placeholder={t10} maxLength={t11} disabled={disabled} className={t12} onChange={onChange} onBlur={onBlur} onFocus={onFocus} aria-label={t13} aria-invalid={t14} aria-errormessage={t15} />;
    $[14] = disabled;
    $[15] = mask;
    $[16] = name;
    $[17] = onBlur;
    $[18] = onChange;
    $[19] = onFocus;
    $[20] = replacement;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== addon) {
    t17 = addon && <div className="form-addon">{addon}</div>;
    $[32] = addon;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t4 || $[37] !== t5) {
    t18 = <div className={t4}>{t5}{t16}{t17}</div>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t4;
    $[37] = t5;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== errMsg || $[40] !== id || $[41] !== name) {
    t19 = errMsg && <div id={`${id || name}-error`} className="form-error-message" role="alert">{errMsg}</div>;
    $[39] = errMsg;
    $[40] = id;
    $[41] = name;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t1 || $[44] !== t18 || $[45] !== t19) {
    t20 = <div>{t1}{t18}{t19}</div>;
    $[43] = t1;
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  return t20;
}